export default __webpack_public_path__ + "locales/el-GR/UploadPanel.json?hash=01b4bb7ac8cdd2f0d03a61de94aa85c0";